import { motion } from "framer-motion";

export default function AuthorSection() {
    return (
        <section id="about" data-testid="author-section" className="relative mx-auto max-w-6xl px-6 py-32">
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                className="book-page rounded-sm px-8 py-12 sm:px-14 sm:py-16"
            >
                <div className="grid items-center gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <div className="author-frame mx-auto max-w-sm">
                            <img
                                src="/assets/author.jpg"
                                alt="Victor M Medina, author of Eve Came First"
                                data-testid="author-photo"
                                className="block w-full rounded-sm"
                            />
                        </div>
                        <p className="font-cinzel mt-7 text-center text-[0.65rem] tracking-[0.35em] text-[#6a5a40] uppercase">
                            A Novel by Victor M. Medina
                        </p>
                        <p className="font-cinzel mt-2 text-center text-2xl tracking-[0.08em] text-[#2b2416] sm:text-3xl">
                            EVE CAME FIRST
                        </p>
                        <p
                            className="font-cormorant mt-4 text-center text-lg italic leading-relaxed text-[#6a5a40]"
                            data-testid="author-dedication"
                        >
                            For my mother — the first garden.
                            <br />
                            Every rose in this story was always yours.
                        </p>
                    </div>

                    <div className="lg:col-span-7">
                        <p className="font-cinzel text-xs tracking-[0.4em] text-[#8a6f3c] uppercase">
                            About the Author
                        </p>
                        <h2 className="font-cinzel mt-5 text-3xl text-[#2b2416] sm:text-4xl">
                            Victor M Medina
                        </h2>
                        <div className="gold-rule-dark mt-6 w-20" />

                        <p className="font-cormorant mt-7 text-lg leading-relaxed text-[#3d3423] sm:text-xl">
                            I write about the wounds men carry — and the women who first teach
                            them love. Eve Came First is my debut novel: a radical reimagining
                            of the oldest story ever told — not a rib, but a womb. Not a
                            temptation, but a mother.
                        </p>
                        <p className="font-cormorant mt-5 text-lg leading-relaxed text-[#3d3423] sm:text-xl">
                            I wrote it while my mother is still alive — my refusal to wait for a
                            eulogy to say what matters. I believe the garden was never lost,
                            only forgotten, and that all healing begins with a single question:
                            what hurts?
                        </p>

                        <blockquote className="font-cormorant mt-9 border-l-2 border-[#b89860] pl-6 text-lg italic leading-loose text-[#4a3f2c] sm:text-xl">
                            "Man lost his way in the patriarchy, and it has left him lonely:
                            always achieving, never whole, fluent in everything except his own
                            heart. I believe a man finds his meaning the day he learns to feel
                            again — and when he can feel, he can finally understand a woman.
                            That is when he comes home."
                        </blockquote>
                        <p className="font-cinzel mt-6 text-sm tracking-[0.25em] text-[#8a6f3c]" data-testid="author-signature">
                            — VICTOR M MEDINA
                        </p>
                    </div>
                </div>

                <div
                    className="mt-14 flex flex-col items-center gap-8 border-t border-[rgba(138,111,60,0.35)] pt-12 sm:flex-row"
                    data-testid="also-by-card"
                >
                    <img
                        src="/assets/aipresidential.webp"
                        alt="AiPresidential — a trilogy novel by Victor M. Medina"
                        data-testid="also-by-cover"
                        className="w-36 rounded-sm shadow-[0_14px_40px_rgba(43,36,22,0.35)] transition-transform duration-500 hover:-translate-y-1 sm:w-44"
                    />
                    <div className="text-center sm:text-left">
                        <p className="font-cinzel text-[0.65rem] tracking-[0.35em] text-[#8a6f3c] uppercase">
                            Also by Victor M. Medina
                        </p>
                        <p className="font-cinzel mt-3 text-xl tracking-[0.06em] text-[#2b2416] sm:text-2xl">
                            AiPRESIDENTIAL
                        </p>
                        <p className="font-cormorant mt-2 max-w-md text-lg italic text-[#4a3f2c]">
                            A trilogy novel — another world, another question worth asking.
                        </p>
                        <a
                            href="https://aipresidential.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="also-by-link"
                            className="font-cinzel mt-5 inline-block rounded-sm border border-[#8a6f3c] px-6 py-3 text-[0.65rem] tracking-[0.25em] text-[#6a5a40] uppercase transition-colors duration-300 hover:bg-[#2b2416] hover:text-[#f3e5ab]"
                        >
                            Visit the Trilogy
                        </a>
                    </div>
                </div>
            </motion.div>
        </section>
    );
}
